/**
 * How the Add lab popup names a lab: the lab chip, its menu, a clinic panel's per-test tag, the
 * "Sent by the clinic to …" line and the search results' lab tag (PROD-3116). Same rule as
 * pm-react's Billing › Labs (PROD-2933, src/billing/lib/lab-display-label.ts):
 *
 *   label    the lab's name when it is short (20 characters or fewer), else its code: "Unilabs"
 *            stays "Unilabs", "National Reference Laboratory" shows as "NRL". With only one of the
 *            two, that one.
 *   tooltip  the full name, so a code label can still be read in full.
 *
 * It takes `name`/`shortCode` (an allowed or default lab). A clinic panel member carries its lab as
 * `effectiveLabName`/`effectiveLabShortCode`; map it first (its own `name` is the test's name).
 */

export const LAB_LABEL_MAX_NAME = 20;

export interface LabNaming {
  name?: string | null;
  shortCode?: string | null;
}

const first = (...values: (string | null | undefined)[]) => {
  for (const v of values) {
    const t = (v ?? '').trim();
    if (t) return t;
  }
  return '';
};

/** The lab's full name, else its code; '' when it has neither. */
export function labFullName(v?: LabNaming | null): string {
  if (!v) return '';
  return first(v.name) || first(v.shortCode);
}

/** "Unilabs", "NRL": the name when it is 20 characters or fewer, else the code. */
export function labDisplayLabel(v?: LabNaming | null): string {
  if (!v) return '';
  const name = first(v.name);
  const code = first(v.shortCode);
  if (name && name.length <= LAB_LABEL_MAX_NAME) return name;
  return code || name;
}
